import React from "react";
import bannerImg from "../../assets/images/automation.png";
import "../../styles/Webdevelopment.css";
import { Link } from "react-router-dom";
function BAbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>
            Business Automation Services to Streamline and Grow Your Business
          </h1>
          <p>
            In nowadays’s speedy-paced digital global, groups are continuously
            searching out smarter ways to improve performance, reduce guide
            paintings, and increase productiveness. This is where{" "}
            <b>business automation services </b> play a essential function. By
            leveraging superior equipment and technology, organizations can
            automate repetitive tasks, minimize mistakes.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span> Business Automation </span>
      </div>
    </div>
  );
}

export default BAbanner;
